import AreYouSure from '../core/AreYouSure';
import WarningIcon from '@material-ui/icons/Warning';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import AddIcon from '@material-ui/icons/Add';
import ExpandMore from '@material-ui/icons/ArrowDropDown';
import ExpandLess from '@material-ui/icons/ArrowDropUp';
import LinkOffIcon from '@material-ui/icons/LinkOff';
import Stop from '@material-ui/icons/Stop';
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router-dom';
import SlatInner from '../core/SlatInner';
import { globalStyles } from '../core/style/gstheme';
import { checkResourceEntitlements, isInOntology } from '../core/utils/utils';
import CreateNodeDialogContainer from './CreateNodeDialogContainer';

const MAX_NODES = 20000;

const styles = () => {
    return Object.assign({
        resourceSlat: {
            minWidth: '250px',
            maxWidth: '500px'
        },
    }, globalStyles);
};

class ResourceSlat extends React.Component {

    state = {
        active: false,
        activeChilden: false,
        areYouSure: false
    };

    onCheckBreakLink = () => {
        this.setState({ areYouSure: true });
    };

    onSure = () => {
        this.setState({ areYouSure: false });
        this.props.onBreakLink(this.props.parentIRI, this.props.data.id);
    };

    onNotSure = () => this.setState({ areYouSure: false });

    setActive = (isActive) => this.setState({ active: isActive });

    activateChildren = () => this.setState({ activeChildren: true });

    deactivateChildren = () => {
        this.setState({ activeChildren: false });
        this.setActive(false);
    };

    render() {

        const { data, onSelect, classes, excludeByPath, onAddNewNode, ontologyIRI, path, onBreakLink, searchClassFilter, searchClass,
            defaultLang, parentIRI, isExpanded, expandNode, collapseNode, selectedTitlePath, titlePath, onAddExistingNode, iriOptions,
            childProperty, createDialog, permissions, addTitle, graph, viewLang, titleTree, useSlashIRI, useUuidIRI } = this.props;
        const { areYouSure } = this.state;

        const notInOntology = (!data.isDefinedBy && !data.visibility)
            || (!(data.isDefinedBy && isInOntology(data.id, data.isDefinedBy, ontologyIRI))
                && data.visibility !== ontologyIRI);
        const isReadOnly = checkResourceEntitlements(data, permissions);
        const resourceCount = data[childProperty] ? data[childProperty].length : 0;

        let label = data.id.includes('#') ?
            decodeURIComponent(data.id.substring(data.id.lastIndexOf('#') + 1))
            :
            decodeURIComponent(data.id.substring(data.id.lastIndexOf('/') + 1));

        const displayLang = viewLang && data.hasOwnProperty("label") && data.label[viewLang] ?
            viewLang
            :
            data.hasOwnProperty("label") && data.label[defaultLang] ?
                defaultLang
                :
                data.hasOwnProperty("label") && data.label["und"] ?
                    "und"
                    :
                    defaultLang;
        if (data.hasOwnProperty("label") && data.label[displayLang]) {
            label = Array.isArray(data.label[displayLang]) ?
                data.label[displayLang].sort().join(" AND ")
                :
                data.label[displayLang];
        }

        const fallbackLang = (viewLang && viewLang !== defaultLang && displayLang === defaultLang)
            || (displayLang === defaultLang && (!data.hasOwnProperty("label") || !data.label[defaultLang]))
            || (displayLang === "und" && viewLang !== "und" && defaultLang !== "und");

        let title = label;
        if (resourceCount > 0) title += " (" + resourceCount + ")";
        const selected = selectedTitlePath.length === 1 && selectedTitlePath[0] === data.id;

        return (
            <div data-test={data.id} className={classes.resourceSlat}>
                <span className={classes.slatIcon}>
                    {data[childProperty] && data[childProperty].length > 0 ?
                        isExpanded ?
                            <ExpandLess data-test="collapse" color="primary" onClick={() => collapseNode(path)} />
                            :
                            data[childProperty].length > MAX_NODES ?
                                <Tooltip data-test="check-warning" title="There are too many resources to expand">
                                    <WarningIcon data-test="warning" />
                                </Tooltip>
                                :
                                <ExpandMore data-test="expand" color="primary" onClick={() => expandNode(path)} />
                        :
                        <Stop style={{ color: 'white' }} />
                    }
                </span>
                <SlatInner
                    show={!isReadOnly && !data.pendingDeletion && this.state.active}
                    title={title}
                    deprecated={data.deprecated}
                    notInScheme={notInOntology}
                    selected={selected}
                    fallbackLang={fallbackLang}
                    titleTree={titleTree}
                    onClick={() => onSelect(data.id, [...titlePath])}
                    onActivate={() => this.setActive(true)}
                    onDeactivate={() => !this.state.activeChildren && this.setActive(false)}>
                    <Tooltip title="Remove (but do not delete) (Alt+click)"
                        onClick={(ev) => {
                            if (ev.altKey) {
                                onBreakLink(parentIRI, data.id);
                            }
                            else {
                                this.onCheckBreakLink();
                            }
                        }}>
                        <IconButton data-test="break-link" className={classes.smallIconButton} style={{ color: 'white' }}>
                            <LinkOffIcon />
                        </IconButton>
                    </Tooltip>
                    {!isReadOnly && onAddNewNode && !data.deprecated &&
                        <CreateNodeDialogContainer
                            button={
                                <Tooltip title={addTitle || "Add a node"} style={{ color: 'white' }}>
                                    <IconButton data-test="add-node" className={classes.smallIconButton}>
                                        <AddIcon />
                                    </IconButton>
                                </Tooltip>
                            }
                            createDialog={createDialog}
                            ontologyIRI={ontologyIRI}
                            useSlashIRI={useSlashIRI}
                            useUuidIRI={useUuidIRI}
                            iriOptions={iriOptions}
                            graph={graph}
                            source={data.id}
                            parentIRI={data.id}
                            excludeByPath={excludeByPath}
                            exclude={[data.id,
                                "https://graphifi.com/schema/xowl/topAnnotationProperty",
                                "http://www.w3.org/2002/07/owl#topObjectProperty",
                                "http://www.w3.org/2002/07/owl#topDataProperty",
                                "http://www.w3.org/2002/07/owl#Thing"
                            ]}
                            onAddExistingNode={onAddExistingNode}
                            onAddNewNode={onAddNewNode}
                            title={addTitle}
                            searchClass={searchClass}
                            searchClassFilter={searchClassFilter}
                            onOpen={this.activateChildren}
                            onClose={this.deactivateChildren}
                        />
                    }
                </SlatInner>
                {areYouSure && <AreYouSure onSure={this.onSure} onNotSure={this.onNotSure} message={[
                    "Confirm unlink this resource.",
                    "This will not delete this resource but simply remove it from the hierarchy at this position."
                ]} />}
            </div>
        );
    }
}

ResourceSlat.propTypes = {
    classes: PropTypes.object,
    ontologyIRI: PropTypes.string.isRequired,
    useSlashIRI: PropTypes.bool,
    useUuidIRI: PropTypes.bool,
    defaultLang: PropTypes.string.isRequired,
    version: PropTypes.number,
    data: PropTypes.object.isRequired,
    existing: PropTypes.array,
    searchClass: PropTypes.string,
    graph: PropTypes.string.isRequired,
    excludeByPath: PropTypes.func,
    searchClassFilter: PropTypes.array.isRequired,
    titlePath: PropTypes.array,
    expandNode: PropTypes.func,
    onAddExistingNode: PropTypes.func,
    onAddNewNode: PropTypes.func,
    viewLang: PropTypes.string,
    selectedTitlePath: PropTypes.array,
    activeResource: PropTypes.string,
    titleTree: PropTypes.array,
    childProperty: PropTypes.string.isRequired,
    onSelect: PropTypes.func.isRequired,
    addTitle: PropTypes.string,
    parentIRI: PropTypes.string.isRequired,
    createDialog: PropTypes.object.isRequired,
    permissions: PropTypes.array.isRequired,
    iriOptions: PropTypes.object
};

export default withRouter(withStyles(styles)(ResourceSlat));